import React, { useState } from 'react';
import { Col, Form, Row, Button, Container } from 'react-bootstrap';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AgeCheckComponent from '../age-check/AgeCheckComponent';
import Logo from '../../images/logo.png';
import {
  setSearchFilter,
} from '../../state/ducks/search/actions';
import ItemNameFilter from '../common/filters/ItemNameFilter';
import ItemCategoryFilter from '../common/filters/ItemCategoryFilter';
import StateFilter from '../common/filters/StateFilter';
import LicenseNumberFilter from '../common/filters/LicenseNumberFilter';
import QuantityTypeFilter from '../common/filters/QuantityTypeFilter';
import PackageIdFilter from '../common/filters/PackageIdFilter';
import config from '../../common/config';
import './HomePage.scss';
import SearchBox from '../search-box/SearchBox';

export default () => {
  const dispatch = useDispatch();
  const history = useNavigate();

  const query = useSelector((state) => state.search.query);
  const searchFilters = useSelector((state) => state.search.filters);

  const [advancedSearch, setAdvancedSearch] = useState(false);

  const onFilterChange = (name, values) =>
    dispatch(setSearchFilter(name, values));

  const search = () => {
    const filters = Object.keys(searchFilters).reduce((acc, curr) => {
      const values = (searchFilters[curr] || []).map((option) => option.value);
      if (values.length) acc[curr] = values;
      return acc;
    }, {});

    history({
      pathname: '/results',
      search: new URLSearchParams({ query, ...filters, sort:'relevancy' }).toString(),
    });
  };

  return (
    <div id="home-page">
      <AgeCheckComponent />
      <div id="background" />
      <div id="stage" className="px-3 px-md-0">
        <div id="logo-container">
          <img src={Logo} alt="Metrc" />
        </div>
        <div id="content">
          <SearchBox></SearchBox>
          <button
            className="mb-3"
            type="button"
            id="filter-toggle"
            onClick={() => setAdvancedSearch(!advancedSearch)}
          >
            Filter Search
            {advancedSearch ? <FaChevronUp /> : <FaChevronDown />}
          </button>
          {advancedSearch && (
            <div id="filters">
              <Container className="px-4 pt-4 pb-3">
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="formState">
                      <Form.Label>State</Form.Label>
                      <StateFilter
                        value={searchFilters.states}
                        onChange={(values) => onFilterChange('states', values)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="formItemName">
                      <Form.Label>Item Name</Form.Label>
                      <ItemNameFilter
                        value={searchFilters.itemNames}
                        requestQueryParams={{
                          states: (searchFilters.states || []).map(
                            (s) => s.value
                          ),
                        }}
                        onChange={(values) =>
                          onFilterChange('itemNames', values)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="formItemCategory">
                      <Form.Label>Item Category</Form.Label>
                      <ItemCategoryFilter
                        value={searchFilters.itemCategories}
                        requestQueryParams={{
                          states: (searchFilters.states || []).map(
                            (s) => s.value
                          ),
                        }}
                        onChange={(values) =>
                          onFilterChange('itemCategories', values)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="formLicenseNumber">
                      <Form.Label>License Number</Form.Label>
                      <LicenseNumberFilter
                        value={searchFilters.licenseNumbers}
                        requestQueryParams={{
                          states: (searchFilters.states || []).map(
                            (s) => s.value
                          ),
                        }}
                        onChange={(values) =>
                          onFilterChange('licenseNumbers', values)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="formQuantityType">
                      <Form.Label>Quantity Type</Form.Label>
                      <QuantityTypeFilter
                        value={searchFilters.quantityTypes}
                        requestQueryParams={{
                          states: (searchFilters.states || []).map(
                            (s) => s.value
                          ),
                        }}
                        onChange={(values) =>
                          onFilterChange('quantityTypes', values)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="formPackageId">
                      <Form.Label>Package ID Number</Form.Label>
                      <PackageIdFilter
                        value={searchFilters.packageIds}
                        requestQueryParams={{
                          states: (searchFilters.states || []).map(
                            (s) => s.value
                          ),
                        }}
                        onChange={(values) =>
                          onFilterChange('packageIds', values)
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Container>
              <Button
                id="search-button"
                className="w-100 btn-lg"
                onClick={() => search()}
              >
                Search
              </Button>
            </div>
          )}
        </div>
      </div>
      <div id="footer">
        <div className="footer_left" />
        <div className="footer_center">
          {config.assemblyCopyright} | {config.assemblyVersion}
        </div>
        <div className="footer_right">
          <small>{config.assemblyInformationalVersion}</small>
        </div>
      </div>
    </div>
  );
};
